import { render, staticRenderFns } from "./ComplaintSummary.vue?vue&type=template&id=07d5ffd5&scoped=true"
import script from "./ComplaintSummary.vue?vue&type=script&lang=js"
export * from "./ComplaintSummary.vue?vue&type=script&lang=js"
import style0 from "./ComplaintSummary.vue?vue&type=style&index=0&id=07d5ffd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5ffd5",
  null
  
)

export default component.exports